<template>
    <div class="shop_trainer">
        <div class="shop_header">
            <div class="shop_header-back" @click="this.$router.go(-1)">
                <img src="../assets/img/arrow.svg" alt="">
            </div>
            {{this.$route.query.categoryName}}
        </div>

        <div class="row">
            <div class="col-lg-6 order-1 order-lg-12">
                <div class="shop_trainer-list">
                    <shop-service-list-item v-for="item in items" :item="item" :key="item.id" />
                </div>
            </div>
            <div class="col-lg-6 order-12  order-lg-1">
                <div class="shop_trainer-profile"
                    :style="{backgroundImage: 'url(' + trainer.photo + ')'}"
                    >
                    <div class="shop_trainer-profile_data">
                        <div class="shop_trainer-profile_rating" v-if="trainer.rating !== undefined && trainer.rating !== 0">
                            <i>
                                <img src="../assets/img/star.svg" alt="">
                            </i>
                            {{trainer.rating}}
                        </div>
                        <div class="shop_trainer-profile_name">
                            {{trainer.name}} {{trainer.surname}}
                        </div>
                        <div class="shop_trainer-profile_position">
                            {{position}}
                        </div>
                    </div>
                    <div class="shop_trainer-profile_reviews" v-if="trainer.review_count !== undefined && trainer.review_count !== 0">
                        {{reviews}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ShopServiceListItem from "../components/shop/ShopServiceListItem";
    import api from "../api";
    import {plural} from "../utilities";
    export default {
        name: 'ShopTrainer',
        components: {ShopServiceListItem},
        data() {
            return {
                trainer: [],
                items: [],
                currentPage: 1,
                isItemsOver: false,
                isFetching: false
            }
        },
        beforeMount() {
            this.$store.commit('SHOW_PRELOADER')
        },
        mounted() {
            this.loadTrainer();
            window.onscroll = () => {
                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight * 0.7;
                if (bottomOfWindow && !this.isFetching && !this.isItemsOver) {
                    this.loadItems();
                }
            }
            this.loadItems();
        },
        computed: {
            reviews() {
                return this.trainer.review_count !== undefined ? plural(this.trainer.review_count, ['отзыв', 'отзыва', 'отзывов']) : ''
            },
            position() {
                let string = this.trainer.function
                let maxLength = 125
                return string !== undefined ? (string.length > maxLength ? string.slice(0, maxLength) + "..." : string) : ''
            },
        },
        methods: {
            async loadTrainer() {
                this.isFetching = true
                let trainerId = this.$route.params.trainerId
                this.trainer = (await api.schedule.getTrainer(trainerId)).data;
            },
            async loadItems() {
                this.isFetching = true
                let trainerId = this.$route.params.trainerId
                let categoryId = this.$route.params.categoryId
                let items = (await api.shop.getCatalogTrainer({
                    params: {
                        trainer_id: trainerId,
                        category_id: categoryId,
                        page: this.currentPage
                    }
                })).data.items;

                if (items.length === 0){
                    this.isItemsOver = true
                }else{
                    this.items = this.items.concat(items)
                    this.currentPage++
                    this.$store.commit('HIDE_PRELOADER')
                }
                this.isFetching = false
            },
        }
    }
</script>
